import './index.rb';
import './index.erb';

import './thermometer.erb';
import './statistics_container.erb';
import './statistics_content.erb';

export default class WeeklyActivityModal {
  constructor() {
    this.container = $('#js-questions-weekly-activity-modal');
    this.showPerformance = this.container.data('show-performance');

    this.thermometherModalBody = $('#weekly-activity-modal-first-body');
    this.statisticsModalBody = $('#weekly-activity-modal-second-body');

    this.thermometherModalFooter = $('#weekly-activity-modal-first-footer');
    this.statisticsModalFooter = $('#weekly-activity-modal-second-footer');

    this.nextModalBtn = $('#weekly-activity-modal-first');
    this.previousModalBtn = $('#weekly-activity-modal-second');

    this.bind();
  }

  loadPerformance() {
    const performanceInfo = $('#user-activity-statistics').data('user-performance');

    const studyingTime = performanceInfo?.data?.length;
    const studyingTimeContainer = $('#actvity-study-time');

    studyingTimeContainer.append(`<p><span>${studyingTime}</span> dias estudando</p>`);

    const hitsContainer = $('#actvity-hit-performance');
    const missesContainer = $('#actvity-miss-performance');

    const hitsCount = performanceInfo?.hit;
    const missesCount = performanceInfo?.miss;

    hitsContainer.append(`${hitsCount}`);
    missesContainer.append(`${missesCount}`);
  }

  showFirstStep() {
    this.thermometherModalBody.show();
    this.statisticsModalBody.hide();
    this.thermometherModalFooter.show();
    this.statisticsModalFooter.hide();
  }

  showSecondStep() {
    this.thermometherModalBody.hide();
    this.statisticsModalBody.show();
    this.thermometherModalFooter.hide();
    this.statisticsModalFooter.show();
  }

  bind() {
    this.previousModalBtn.on('click', () => this.showFirstStep());
    this.nextModalBtn.on('click', () => this.showSecondStep());

    if (this.showPerformance) {
      this.loadPerformance();
    }
  }
}
